import { useEffect, useState } from 'react'
import { StepContent } from '../stepper/StepContent'
import { CreatorButtonsGo } from './CreatorButtonsGo'
import { useNavigate } from 'react-router-dom'
import { CreatorGoProps } from './CreatorGo'
import { usePreferences } from '@/hooks/preferences/usePreferences'
import { TimeSlotsSelection } from '../common/TimeSlotsSelection'
import { useUser } from '@/hooks/user/useUser'
import { useSlots } from '@/hooks/slots/useSlots'
import { ISlot } from '@namuho/types'
import { useDispatch } from 'react-redux'
import { CreatorGoSteps, markStepCompleted } from '@/slices/creatorGo'
import { StepTitle } from '../stepper/StepTitle'

export const DatesGo = (props: CreatorGoProps) => {
    const { dateType } = props
    const { userData, isLoading } = useUser()
    const { isLoading: isLoadingSlots } = useSlots()
    const navigate = useNavigate()
    const [selectedDates, setSelectedDates] = useState<ISlot[]>([])
    const { updateTimeSlots } = usePreferences()
    const dispatch = useDispatch()

    const handleTimeSlotAdd = (slot: ISlot) => {
        setSelectedDates((prev) => {
            const alreadySelectedIds = prev.map((slot) => slot.id)
            const newSlotId = slot.id
            if (alreadySelectedIds.includes(newSlotId)) {
                return prev
            } else {
                return [...prev, slot]
            }
        })
    }

    const handleTimeSlotRemove = (slot: ISlot) => {
        setSelectedDates((prev) => prev.filter((date) => date.id !== slot.id))
    }

    const handleNext = async () => {
        if (selectedDates.length > 2) {
            dispatch(markStepCompleted({ dateType: dateType, step: CreatorGoSteps.DATES }))
        }
        updateTimeSlots(selectedDates)
        navigate('/')
    }

    useEffect(() => {
        const availableDates = userData?.timeSlots
        setSelectedDates(availableDates ?? [])
    }, [userData?.timeSlots])

    return (
        <StepContent
            title={<StepTitle title="Bitte teile uns deine möglichen Termine mit (mindestens 3)" />}
            content={<TimeSlotsSelection onTimeSlotAdd={handleTimeSlotAdd} onTimeSlotRemove={handleTimeSlotRemove} timeSlots={selectedDates} />}
            buttons={
                <CreatorButtonsGo
                    dateType={dateType}
                    nextStepActive={selectedDates.length > 2}
                    previousStepActive={true}
                    isFirst={false}
                    isLast={true}
                    handleNext={handleNext}
                />
            }
        />
    )
}
